import { CardBox } from '@aibees/shared/components';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(CardBox)`
  margin: auto;
  padding: ${(p) => p.theme.spacing(6, 7)};
  max-width: ${(p) => p.theme.spacing(47)};
  border-radius: ${(p) => p.theme.spacing(4)};
`;
